export default __webpack_public_path__ + "static/media/icon-medium.d12f5c4e.svg";